/**
 * @fileoverview gRPC-Web generated client stub for io.codedrills.proto.user
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js')

var io_codedrills_proto_content_preview_pb = require('../../../../io/codedrills/proto/content/preview_pb.js')

var io_codedrills_proto_user_candidate_pb = require('../../../../io/codedrills/proto/user/candidate_pb.js')

var io_codedrills_proto_user_candidate_status_pb = require('../../../../io/codedrills/proto/user/candidate_status_pb.js')
const proto = {};
proto.io = {};
proto.io.codedrills = {};
proto.io.codedrills.proto = {};
proto.io.codedrills.proto.user = require('./hiring_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.user.HiringServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetCandidatesForTestRequest,
 *   !proto.io.codedrills.proto.user.GetCandidatesForTestResponse>}
 */
const methodInfo_HiringService_GetCandidatesForTest = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetCandidatesForTestResponse,
  /** @param {!proto.io.codedrills.proto.user.GetCandidatesForTestRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetCandidatesForTestResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetCandidatesForTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetCandidatesForTestResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetCandidatesForTestResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.getCandidatesForTest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/GetCandidatesForTest',
      request,
      metadata || {},
      methodInfo_HiringService_GetCandidatesForTest,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetCandidatesForTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetCandidatesForTestResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.getCandidatesForTest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/GetCandidatesForTest',
      request,
      metadata || {},
      methodInfo_HiringService_GetCandidatesForTest);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.TestInviteRequest,
 *   !proto.io.codedrills.proto.user.TestInviteResponse>}
 */
const methodInfo_HiringService_TestInvite = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.TestInviteResponse,
  /** @param {!proto.io.codedrills.proto.user.TestInviteRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.TestInviteResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.TestInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.TestInviteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.TestInviteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.testInvite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/TestInvite',
      request,
      metadata || {},
      methodInfo_HiringService_TestInvite,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.TestInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.TestInviteResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.testInvite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/TestInvite',
      request,
      metadata || {},
      methodInfo_HiringService_TestInvite);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.TestInviteByUrlRequest,
 *   !proto.io.codedrills.proto.user.TestInviteByUrlResponse>}
 */
const methodInfo_HiringService_TestInviteByUrl = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.TestInviteByUrlResponse,
  /** @param {!proto.io.codedrills.proto.user.TestInviteByUrlRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.TestInviteByUrlResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.TestInviteByUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.TestInviteByUrlResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.TestInviteByUrlResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.testInviteByUrl =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/TestInviteByUrl',
      request,
      metadata || {},
      methodInfo_HiringService_TestInviteByUrl,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.TestInviteByUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.TestInviteByUrlResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.testInviteByUrl =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/TestInviteByUrl',
      request,
      metadata || {},
      methodInfo_HiringService_TestInviteByUrl);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.TestInviteBatchRequest,
 *   !proto.io.codedrills.proto.user.TestInviteBatchResponse>}
 */
const methodInfo_HiringService_TestInviteBatch = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.TestInviteBatchResponse,
  /** @param {!proto.io.codedrills.proto.user.TestInviteBatchRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.TestInviteBatchResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.TestInviteBatchRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.TestInviteBatchResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.TestInviteBatchResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.testInviteBatch =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/TestInviteBatch',
      request,
      metadata || {},
      methodInfo_HiringService_TestInviteBatch,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.TestInviteBatchRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.TestInviteBatchResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.testInviteBatch =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/TestInviteBatch',
      request,
      metadata || {},
      methodInfo_HiringService_TestInviteBatch);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.FetchCandidateReportRequest,
 *   !proto.io.codedrills.proto.user.FetchCandidateReportResponse>}
 */
const methodInfo_HiringService_FetchCandidateReport = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.FetchCandidateReportResponse,
  /** @param {!proto.io.codedrills.proto.user.FetchCandidateReportRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.FetchCandidateReportResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.FetchCandidateReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.FetchCandidateReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.FetchCandidateReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.fetchCandidateReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/FetchCandidateReport',
      request,
      metadata || {},
      methodInfo_HiringService_FetchCandidateReport,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.FetchCandidateReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.FetchCandidateReportResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.fetchCandidateReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/FetchCandidateReport',
      request,
      metadata || {},
      methodInfo_HiringService_FetchCandidateReport);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.UpdateCandidateStageRequest,
 *   !proto.io.codedrills.proto.user.UpdateCandidateStageResponse>}
 */
const methodInfo_HiringService_UpdateCandidateStage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.UpdateCandidateStageResponse,
  /** @param {!proto.io.codedrills.proto.user.UpdateCandidateStageRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.UpdateCandidateStageResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.UpdateCandidateStageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.UpdateCandidateStageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.UpdateCandidateStageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.updateCandidateStage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/UpdateCandidateStage',
      request,
      metadata || {},
      methodInfo_HiringService_UpdateCandidateStage,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.UpdateCandidateStageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.UpdateCandidateStageResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.updateCandidateStage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/UpdateCandidateStage',
      request,
      metadata || {},
      methodInfo_HiringService_UpdateCandidateStage);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.FetchCustomerAllTestRequest,
 *   !proto.io.codedrills.proto.user.FetchCustomerAllTestResponse>}
 */
const methodInfo_HiringService_FetchCustomerAllTest = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.FetchCustomerAllTestResponse,
  /** @param {!proto.io.codedrills.proto.user.FetchCustomerAllTestRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.FetchCustomerAllTestResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.FetchCustomerAllTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.FetchCustomerAllTestResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.FetchCustomerAllTestResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.fetchCustomerAllTest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/FetchCustomerAllTest',
      request,
      metadata || {},
      methodInfo_HiringService_FetchCustomerAllTest,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.FetchCustomerAllTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.FetchCustomerAllTestResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.fetchCustomerAllTest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/FetchCustomerAllTest',
      request,
      metadata || {},
      methodInfo_HiringService_FetchCustomerAllTest);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.DeleteCandidatesRequest,
 *   !proto.io.codedrills.proto.user.DeleteCandidatesResponse>}
 */
const methodInfo_HiringService_DeleteCandidates = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.DeleteCandidatesResponse,
  /** @param {!proto.io.codedrills.proto.user.DeleteCandidatesRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.DeleteCandidatesResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.DeleteCandidatesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.DeleteCandidatesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.DeleteCandidatesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.deleteCandidates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/DeleteCandidates',
      request,
      metadata || {},
      methodInfo_HiringService_DeleteCandidates,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.DeleteCandidatesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.DeleteCandidatesResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.deleteCandidates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/DeleteCandidates',
      request,
      metadata || {},
      methodInfo_HiringService_DeleteCandidates);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.UpdateCandidateRatingRequest,
 *   !proto.io.codedrills.proto.user.UpdateCandidateRatingResponse>}
 */
const methodInfo_HiringService_UpdateCandidateRating = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.UpdateCandidateRatingResponse,
  /** @param {!proto.io.codedrills.proto.user.UpdateCandidateRatingRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.UpdateCandidateRatingResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.UpdateCandidateRatingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.UpdateCandidateRatingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.UpdateCandidateRatingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.updateCandidateRating =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/UpdateCandidateRating',
      request,
      metadata || {},
      methodInfo_HiringService_UpdateCandidateRating,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.UpdateCandidateRatingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.UpdateCandidateRatingResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.updateCandidateRating =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/UpdateCandidateRating',
      request,
      metadata || {},
      methodInfo_HiringService_UpdateCandidateRating);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.UpdateCandidateNotesRequest,
 *   !proto.io.codedrills.proto.user.UpdateCandidateNotesResponse>}
 */
const methodInfo_HiringService_UpdateCandidateNotes = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.UpdateCandidateNotesResponse,
  /** @param {!proto.io.codedrills.proto.user.UpdateCandidateNotesRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.UpdateCandidateNotesResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.UpdateCandidateNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.UpdateCandidateNotesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.UpdateCandidateNotesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.updateCandidateNotes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/UpdateCandidateNotes',
      request,
      metadata || {},
      methodInfo_HiringService_UpdateCandidateNotes,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.UpdateCandidateNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.UpdateCandidateNotesResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.updateCandidateNotes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/UpdateCandidateNotes',
      request,
      metadata || {},
      methodInfo_HiringService_UpdateCandidateNotes);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.EmailCandidateRequest,
 *   !proto.io.codedrills.proto.user.EmailCandidateResponse>}
 */
const methodInfo_HiringService_EmailCandidate = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.EmailCandidateResponse,
  /** @param {!proto.io.codedrills.proto.user.EmailCandidateRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.EmailCandidateResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.EmailCandidateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.EmailCandidateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.EmailCandidateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.emailCandidate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/EmailCandidate',
      request,
      metadata || {},
      methodInfo_HiringService_EmailCandidate,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.EmailCandidateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.EmailCandidateResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.emailCandidate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/EmailCandidate',
      request,
      metadata || {},
      methodInfo_HiringService_EmailCandidate);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.FetchCustomerJobsRequest,
 *   !proto.io.codedrills.proto.user.FetchCustomerJobsResponse>}
 */
const methodInfo_HiringService_FetchCustomerJobs = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.FetchCustomerJobsResponse,
  /** @param {!proto.io.codedrills.proto.user.FetchCustomerJobsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.FetchCustomerJobsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.FetchCustomerJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.FetchCustomerJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.FetchCustomerJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.fetchCustomerJobs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/FetchCustomerJobs',
      request,
      metadata || {},
      methodInfo_HiringService_FetchCustomerJobs,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.FetchCustomerJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.FetchCustomerJobsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.fetchCustomerJobs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/FetchCustomerJobs',
      request,
      metadata || {},
      methodInfo_HiringService_FetchCustomerJobs);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.LinkJobWithTestRequest,
 *   !proto.io.codedrills.proto.user.LinkJobWithTestResponse>}
 */
const methodInfo_HiringService_LinkJobWithTest = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.LinkJobWithTestResponse,
  /** @param {!proto.io.codedrills.proto.user.LinkJobWithTestRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.LinkJobWithTestResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.LinkJobWithTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.LinkJobWithTestResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.LinkJobWithTestResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.linkJobWithTest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/LinkJobWithTest',
      request,
      metadata || {},
      methodInfo_HiringService_LinkJobWithTest,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.LinkJobWithTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.LinkJobWithTestResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.linkJobWithTest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/LinkJobWithTest',
      request,
      metadata || {},
      methodInfo_HiringService_LinkJobWithTest);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetJobCandidatesRequest,
 *   !proto.io.codedrills.proto.user.GetJobCandidatesResponse>}
 */
const methodInfo_HiringService_GetJobCandidates = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetJobCandidatesResponse,
  /** @param {!proto.io.codedrills.proto.user.GetJobCandidatesRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetJobCandidatesResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetJobCandidatesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetJobCandidatesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetJobCandidatesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.getJobCandidates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/GetJobCandidates',
      request,
      metadata || {},
      methodInfo_HiringService_GetJobCandidates,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetJobCandidatesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetJobCandidatesResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.getJobCandidates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/GetJobCandidates',
      request,
      metadata || {},
      methodInfo_HiringService_GetJobCandidates);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetAllJobSkillsRequest,
 *   !proto.io.codedrills.proto.user.GetAllJobSkillsResponse>}
 */
const methodInfo_HiringService_GetAllJobSkills = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetAllJobSkillsResponse,
  /** @param {!proto.io.codedrills.proto.user.GetAllJobSkillsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetAllJobSkillsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetAllJobSkillsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetAllJobSkillsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetAllJobSkillsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.getAllJobSkills =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/GetAllJobSkills',
      request,
      metadata || {},
      methodInfo_HiringService_GetAllJobSkills,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetAllJobSkillsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetAllJobSkillsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.getAllJobSkills =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/GetAllJobSkills',
      request,
      metadata || {},
      methodInfo_HiringService_GetAllJobSkills);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.RegenerateTestReportRequest,
 *   !proto.io.codedrills.proto.user.RegenerateTestReportResponse>}
 */
const methodInfo_HiringService_RegenerateTestReport = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.RegenerateTestReportResponse,
  /** @param {!proto.io.codedrills.proto.user.RegenerateTestReportRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.RegenerateTestReportResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.RegenerateTestReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.RegenerateTestReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.RegenerateTestReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.HiringServiceClient.prototype.regenerateTestReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/RegenerateTestReport',
      request,
      metadata || {},
      methodInfo_HiringService_RegenerateTestReport,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.RegenerateTestReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.RegenerateTestReportResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.HiringServicePromiseClient.prototype.regenerateTestReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.HiringService/RegenerateTestReport',
      request,
      metadata || {},
      methodInfo_HiringService_RegenerateTestReport);
};


module.exports = proto.io.codedrills.proto.user;

